import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import { Icon as DSIcon } from "quorumdesign"

/**
 * Load a Sheet Cell that displays a FontAwesome 5 Icon using the Quorum Design System
 * @param  {String} icon [fa5 icon to display ex. "eye"]
 * @param  {String} label [text to display to the right of icon]
 */
export const IconCell = ({ icon, label, iconFamily = "fal", isTruthy }) => {
    return (
        <span
            className={classNames({
                "fa5-icon-cell": true,
                "truthy": isTruthy,
                "falsy": !isTruthy
            })}
        >
            <span className="type-icon">
                <DSIcon
                    icon={icon}
                    iconFamily={iconFamily}
                    size="lg"
                />
            </span>
            <label>
                {label}
            </label>
        </span>
    )
}

IconCell.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconFamily: PropTypes.string,
    isTruthy: PropTypes.bool,
}

export default IconCell
